module.exports = __webpack_public_path__ + "img/icon_ecosystem_services.b0791c47.svg";